import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import {
  useCancelCurrencyExchangeInstructionMutation
} from '../../../../api/currency-exchanges/currencyExchangeInstructionApi'
import { RtkQueryHelper } from '../../../../api/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import OtpComponent from '../../../auth/components/OtpComponent'
import { setNotification } from '../../../shared/components/ui-widgets/uiWidgetsSlice'

interface CancelExchangeInstructionComponentProps {
  assetHolderId: number
  instructionId: number
  onCloseDialog: () => void
}

const CancelExchangeInstructionComponent: React.FC<CancelExchangeInstructionComponentProps> = ({
  assetHolderId,
  instructionId,
  onCloseDialog
}: CancelExchangeInstructionComponentProps) => {
  const dispatch = useAppDispatch()

  const [apiCancelInstructionApi, { isLoading }] = useCancelCurrencyExchangeInstructionMutation()

  const handleCancelInstruction = (otp: string): void => {
    apiCancelInstructionApi({ assetHolderId, instructionId, otp })
      .unwrap()
      .then(() => {
        dispatch(setNotification({
          open: true,
          severity: 'success',
          message: 'Your ZAR Payout in BTC instruction has been successfully cancelled.'
        }))
        onCloseDialog()
      })
      .catch((err) => {
        dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(err) }))
      })
  }
  return (
    <>
      <Dialog
        open={true}
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown={true}
        onClose={() => { onCloseDialog() }}
        sx={{ p: 2 }}
      >
        <DialogTitle>Cancel ZAR Payout In BTC</DialogTitle>

        <DialogContent>
          <Typography variant={'body1'}>You are about to cancel your pending ZAR Payout In BTC Instruction. Are you sure you wish to continue? </Typography>
          <Box display={'flex'} justifyContent={'space-between'} sx={{ mt: 2 }}>
            <OtpComponent
              assetHolderId={assetHolderId}
              actionName={'Continue'}
              authenticatorConfigured={null}
              isLoading={isLoading}
              executeAction={(otp: string) => { handleCancelInstruction(otp) }}
              disabled={false}
            />

            <Button
              variant={'outlined'}
              type="button"
              sx={{ ml: 2 }}
              onClick={() => { onCloseDialog() }}
            >
              Cancel
            </Button>
          </Box>
        </DialogContent>

      </Dialog>
    </>
  )
}

export default CancelExchangeInstructionComponent
